module.exports = __webpack_public_path__ + "static/media/Profile-photo-Filip.fc0d9134.jpg";